import { hasWordIntegration } from '../wordIntegration/index.js';
// Signed documents come from Word, so signing is on only while Word integration is.
export const hasDocumentSigning = (government) => government.hasDocumentSigning === true && hasWordIntegration(government);
